<template>
  <div class="content-wrapper">
    <section class="content-header">
      <div class="container-fluid">
        <div class="row mb-2">
          <div class="col-sm-12">
            <h1>
              Rules
              <router-link
                :to="{ name: 'RuleAdd' }"
                class="btn ml-auto"
                v-if="actionCreate"
              >
                <i class="icon-plus"></i> New
              </router-link>
            </h1>
          </div>
          <div class="col-sm-6">
            <ol class="breadcrumb float-sm-right">
              <li class="breadcrumb-item">
                <router-link :to="{ name: 'Home' }">Home</router-link>
              </li>
              <li class="breadcrumb-item active">Rules</li>
            </ol>
          </div>
        </div>
      </div>
      <!-- /.container-fluid -->
    </section>

    <section class="content" v-if="has_permission === true">
      <div class="container-fluid">
        <div class="card">
          <div
            class="card-header py-3"
            v-if="!_.isEmpty(list.data) && is_loading == false"
          >
            <div class="btn-toolbar pull-right">
              <button
                class="btn btn-info"
                type="button"
                @click="showFilter = !showFilter"
              >
                <i class="fa fa-filter"></i> Filter
              </button>
            </div>
          </div>
          <div class="overlay" v-if="is_loading">
            <img src="/assets/images/loader.svg" alt="" />
          </div>
          <form @submit.prevent="getFilterData()" method="GET" novalidate>
            <div class="card-body pb-0" v-if="showFilter">
              <div>
                <div class="form-row">
                  <div class="col-md-6">
                    <!-- Audra -->
                    <div class="form-group form-row" v-if="organizationId == 1">
                      <label class="col-md-3 col-form-label" for="audraname">Audra</label>
                      <div class="col-md-9">
                        <div class="input-group">
                          <multiselect
                            v-model="filter.accountId"
                            :options="Object.keys(pre.audraName)"
                            :custom-label="(opt) => pre.audraName[opt]"
                            placeholder="Select Audra"
                            :searchable="true"
                            :multiple="false"
                            id="accountId"
                            v-bind:class="{
                              'has-error': errors.has('accountId'),
                            }"
                            name="accountId"
                          >
                          </multiselect>
                        </div>
                      </div>
                    </div>
                    <div class="form-group form-row" v-if="1 == 0">
                      <label class="col-md-3 col-form-label" for="mstatus">Source</label>
                      <div class="col-md-9">
                        <div class="input-group">
                          <input
                            autocomplete="off"
                            type="text"
                            id="source_address"
                            name="source_address"
                            v-model="filter.source_address"
                            :class="{
                              'has-error': errors.has('source_address'),
                            }"
                            class="form-control"
                            placeholder="Source Address"
                          />
                        </div>
                      </div>
                    </div>

                    <div class="form-group form-row">
                      <label class="col-md-3 col-form-label" for="rule_name"
                        >Rule Name</label
                      >
                      <div class="col-md-9">
                        <div class="input-group">
                          <input
                            autocomplete="off"
                            type="text"
                            id="rule_name"
                            name="rule_name"
                            v-model="filter.rule_name"
                            :class="{
                              'has-error': errors.has('rule_name'),
                            }"
                            class="form-control"
                            placeholder="Rule Name"
                          />
                        </div>
                      </div>
                    </div>
                    <div class="form-group form-row">
                      <label class="col-md-3 col-form-label" for="action">Type</label>
                      <div class="col-md-9">
                        <div class="input-group">
                          <multiselect
                            v-model="filter.action"
                            :options="Object.keys(pre.action)"
                            :custom-label="(opt) => pre.action[opt]"
                            :searchable="false"
                            :multiple="false"
                            id="action"
                            v-bind:class="{
                              'has-error': errors.has('action'),
                            }"
                            name="action"
                          >
                          </multiselect>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-6">
                    <div class="row justify-content-end">
                      <div class="col-md-9">
                        <button type="submit" class="btn mr-3">
                          <i class="icon-search"></i> Search
                        </button>
                        <button
                          type="reset"
                          class="btn btn-outline"
                          @click="resetFilter()"
                        >
                          <i class="icon-refresh"></i> Reset
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </form>

          <div class="card-body">
            <div v-if="!_.isEmpty(list.data) && is_loading == false">
              <div class="d-flex justify-content-between align-items-center mb-3">
                <h6>Total Item: {{ list.total }}</h6>
              </div>
              <div class="table-responsive-md">
                <table class="table">
                  <thead>
                    <tr>
                      <th v-if="organizationId == 1">Audra</th>
                      <th>Source</th>
                      <th>Rule Name</th>
                      <th>Duration</th>
                      <th>Time Category</th>
                      <th>Type</th>
                      <th class="text-right">Action</th>
                    </tr>
                  </thead>
                  <tbody class="list">
                    <tr v-for="(val, index) in list.data">
                      <td v-if="organizationId == 1">
                        {{
                          pre.audraName[val.accountId]
                            ? pre.audraName[val.accountId]
                            : "NA"
                        }}
                      </td>
                      <td>{{ processSource(val) }}</td>
                      <td>{{ processRuleName(val) }}</td>
                      <td>{{ processDuration(val.duration) }}</td>
                      <td>{{ processTimeCategory(val) }}</td>
                      <td>{{ processAction(val.action) }}</td>
                      <td class="text-right">
                        <!-- v-if="actionDelete == true || checkDeletePermission(val)" -->
                        <a
                          v-if="
                            val.priority != 32 &&
                            val.priority != 43 &&
                            val.priority != 33 &&
                            val.priority != 22
                          "
                          class="btn btn-trash"
                          href="javascript:void(0)"
                          @click="deleteObject(val.id, val.accountId, index)"
                          ><i class="icon-trash"></i
                        ></a>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <div class="p-4" v-if="_.isEmpty(list.data) && is_loading == false">
              <div class="no-data">
                <img src="/assets/images/no-data.svg" alt="" />
                <h3>No data found!</h3>
              </div>
            </div>
          </div>

          <div :class="{ 'card-footer': list.total > list.per_page }">
            <vue-pagination
              :pagination="list"
              v-if="list.total > list.per_page"
              @paginate="reload()"
            ></vue-pagination>
          </div>
        </div>
      </div>
    </section>

    <section class="content" v-if="has_permission === false">
      <div class="alert alert-danger alert-dismissible">
        <h5><i class="icon fas fa-ban"></i> Permission denied!</h5>
      </div>
    </section>
  </div>
</template>

<script>
import VuePagination from "@/components/partials/PaginationComponent";
import SortIcons from "@/components/utils/SortIcons";
import { CommonAPI, PermissionChecker } from "@/services/api";
import LocalStorage from "@/services/localStorage";
import axios from "axios";
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import { mapGetters } from "vuex";
const fileDownload = require("js-file-download");
import Vue from "vue"; // Import Vue

Vue.directive("replaceSpace", {
  update(el) {
    el.value = el.value.replace(/ /g, "_");
    el.dispatchEvent(new Event("input"));
  },
});

export default {
  name: "Rule",
  metaInfo: {
    title: "Rules | Dotlines",
  },
  components: {
    DatePicker,
    VuePagination,
    SortIcons,
  },
  data: () => ({
    organizationId: LocalStorage.get("organizationId"),
    userEmail: LocalStorage.get("userEmail"),
    list: {
      total: 0,
      per_page: 10,
      from: 1,
      to: 0,
      current_page: 1,
    },
    actionCreate: false,
    actionView: false,
    actionEdit: false,
    actionDelete: true,
    api_url: "",
    showFilter: false,
    filter: {},
    dateRange: "",
    pre: {
      audraName: [],
      timeCategories: [],
      deviceNames: [],
      action: {
        0: "BLOCK",
        1: "ALLOW",
      },
    },
    is_loading: false,
    empty: false,
    empty_message: "",
    custom_permission_data: [],
    has_permission: true,
    selected_row: [],
    is_selected_all: false,
  }),
  mounted: function () {
    if (this.isMobile()) {
      window.$(document).find(".push-menu-class").trigger("click");
    }
    this.api_url = "/rules";
    this.initialize();
    this.$root.$on("sort-data", () => {
      this.$root.$emit("show-icon");
      this.reload();
    });
  },
  computed: {
    ...mapGetters(["profile"]),
  },
  methods: {
    async initialize() {
      this.is_loading = true;
      if (_.isEmpty(this.profile)) {
        await CommonAPI.getProfile().then((profile_info) => {
          this.user_detail = profile_info;
        });
      } else {
        this.user_detail = this.profile;
      }

      // await CommonAPI.getCustomPermission(
      //   "/get-custom-permission-infos?path=api/rules"
      // ).then((response) => {
      //   if (response.status == 200) {
      //     this.custom_permission_data = response.data;
      //   }
      // });

      // if (!_.isEmpty(this.custom_permission_data)) {
      //   this.actionCreate = await PermissionChecker.checkCreateButtonPermission(
      //     this.custom_permission_data.action_permission,
      //     this.custom_permission_data["create_id_condition"],
      //     this.user_detail,
      //     this.custom_permission_data.enableAdministratorPermissionByDefault
      //   );
      // }

      await this.getList()
        .then((response) => {
          this.list = response.data;
        })
        .catch((error) => {
          this.empty = true;
          if (error.response.status === 403) {
            this.has_permission = false;
          }
        });

      await CommonAPI.getAudraName(LocalStorage.get("accountId"))
        .then((response) => {
          this.pre.audraName = response;
        })
        .catch((error) => {
          console.log(error.response);
        });

      await this.getDeviceNames()
        .then((response) => {
          this.pre.deviceNames = response.data;
        })
        .catch((error) => {
          console.log(error.response);
        });

      await this.getTimeCategories()
        .then((response) => {
          this.pre.timeCategories = response.data;
        })
        .catch((error) => {
          console.log(error.response);
        });

      this.is_loading = false;
    },
    async getFilterData() {
      this.is_loading = true;
      await this.getList()
        .then((response) => {
          this.list = response.data;
        })
        .catch((error) => {
          this.empty = true;
          if (error.response.status === 403) {
            this.has_permission = false;
          }
        });
      this.is_loading = false;
    },
    reload: function () {
      this.getList()
        .then((response) => {
          this.list = response.data;
        })
        .catch((error) => {
          this.empty = true;
          if (error.response.status === 403) {
            this.has_permission = false;
          }
        });
    },
    getList: function () {
      return new Promise((resolve, reject) => {
        let params = { page: this.list.current_page };
        params = {
          ...this.filter,
          userAccountId: LocalStorage.get("accountId"),
          ...this.$route.query,
          ...params,
        };
        axios
          .get(this.api_url, {
            params: params,
          })
          .then((response) => {
            resolve(response);
          })
          .catch((error) => {
            reject(error);
          })
          .finally(() => {});
      });
    },
    checkEditPermission: function (data) {
      if (!_.isEmpty(this.custom_permission_data)) {
        return PermissionChecker.checkEditButtonPermission(
          this.custom_permission_data.action_permission,
          this.custom_permission_data["edit_id_condition"],
          this.custom_permission_data["edit_refid_condition"],
          this.custom_permission_data["edit_custom_condition"],
          data,
          this.user_detail,
          this.custom_permission_data.enableAdministratorPermissionByDefault
        );
      } else {
        return false;
      }
    },
    checkDeletePermission: function (data) {
      if (!_.isEmpty(this.custom_permission_data)) {
        return PermissionChecker.checkDeleteButtonPermission(
          this.custom_permission_data.action_permission,
          this.custom_permission_data["delete_id_condition"],
          this.custom_permission_data["delete_refid_condition"],
          this.custom_permission_data["delete_custom_condition"],
          data,
          this.user_detail,
          this.custom_permission_data.enableAdministratorPermissionByDefault
        );
      } else {
        return false;
      }
    },
    async resetFilter() {
      this.list.current_page = 1;
      this.filter = {};
      this.is_loading = true;
      await this.getList()
        .then((response) => {
          this.list = response.data;
        })
        .catch((error) => {
          this.empty = true;

          if (error.response.status === 403) {
            this.has_permission = false;
          }
        });
      this.is_loading = false;
    },
    deleteObject: function (id, accountId, index) {
      const _this = this;
      const delete_api_url = "/rules/" + id + "|" + accountId;
      _this.$swal
        .fire({
          title: "Are you sure?",
          text: "You won't be able to revert this!",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Yes, delete it!",
        })
        .then((result) => {
          if (result.isConfirmed) {
            _this.is_loading = true;
            axios
              .delete(delete_api_url)
              .then((responses) => {
                _this.list.data.splice(index, 1);

                _this
                  .getList()
                  .then((response) => {
                    _this.list = response.data;
                    _this.$toaster.success(responses.data.message);
                    _this.is_loading = false;
                  })
                  .catch((error) => {
                    console.log("Failed to refresh list", error);
                    _this.is_loading = false;
                  });
              })
              .catch((error) => {
                _this.is_loading = false;
                _this.$swal.fire("Failed!", "failed to delete.", "error");
              })
              .finally(() => {
                _this.is_loading = false;
              });
          }
        });
    },

    getDeviceNames: function () {
      return new Promise((resolve) => {
        axios
          .get("/get-rule-device-names", {
            params: { accountId: LocalStorage.get("accountId") },
          })
          .then((response) => {
            resolve(response);
          })
          .catch((error) => {
            console.log("error " + error);
            resolve(error);
          });
      });
    },
    getTimeCategories: function () {
      return new Promise((resolve) => {
        axios
          .get("/get-time-categories")
          .then((response) => {
            resolve(response);
          })
          .catch((error) => {
            console.log("error " + error);
            resolve(error);
          });
      });
    },

    processSource(val) {
      if (val.acttype == "all") {
        return val.source_address.replace("__", "").toUpperCase();
      } else {
        return this.pre.deviceNames[val.source_address]
          ? this.pre.deviceNames[val.source_address].toUpperCase()
          : "NO NAME";
      }
    },

    processRuleName(val) {
      let ruleName = val.rule_name.replace(/--/g, " ");
      ruleName = ruleName.replace(/_/g, " ");
      return ruleName.toUpperCase();
    },

    processDuration(duration) {
      return duration == null || duration == 0
        ? "N/A"
        : duration / 60 > 1
        ? "DAILY " + duration / 60 + " HOURS"
        : "DAILY " + duration / 60 + " HOUR";
    },

    processTimeCategory(val) {
      return val.block_category == null
        ? "N/A"
        : this.ucwords(val.block_category) + this.pre.timeCategories[val.profile_id];
    },

    processAction(blocked) {
      return blocked == 1 ? "ALLOW" : "BLOCK";
    },

    ucwords(str) {
      return str.toLowerCase().replace(/\b[a-z]/g, function (letter) {
        return letter.toUpperCase();
      });
    },
  },
  watch: {
    "filter.rule_name": function (newVal) {
      this.filter.rule_name = newVal.replace(/ /g, "--");
    },
  },
  /* created() {
    this.$emit("update:layout", MasterLayout);
  }, */
};
</script>
